export default "__VITE_ASSET__BPwqTTgh__"